import api from '@pray/shared/utils/api';

import type { WorkflowVersionResponse } from './data/response';
import type { PublishWorkflowVersionRequest } from './data/types';

type PublishVersionProps = {
  artistId: string;
  workflowId: string;
  draft: PublishWorkflowVersionRequest;
};

export async function publishVersion({
  artistId,
  workflowId,
  draft,
}: PublishVersionProps): Promise<WorkflowVersionResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');
  if (!draft.version_id) throw new Error('Draft version ID is required');
  if (!draft.expected_draft_revision) throw new Error('Draft revision is required');
  if (!draft.expected_snapshot_hash) throw new Error('Draft snapshot hash is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions/${draft.version_id}/publish`;
  const response = await api.executePutRequest<WorkflowVersionResponse>(url, {
    expected_draft_revision: draft.expected_draft_revision,
    expected_snapshot_hash: draft.expected_snapshot_hash,
  });

  return response.data;
}
